import { UserType } from '../../types';
import { apiError } from '../../utils/errors';

interface LinkTokenResponse {
  link_token: string;
  expiration: string;
}

const REQUEST_TIMEOUT_MS = 30_000;

export const getLinkToken = async (
  urlSlug: string,
  publicId: string,
  userType: UserType,
): Promise<LinkTokenResponse> => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  try {
    const isSigner = userType === UserType.SIGNER;
    const response = await fetch(`${process.env.REACT_APP_API_URL}/submissions/${urlSlug}/${publicId}/plaid/link-token?isSigner=${isSigner}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      signal: controller.signal,
    });

    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      throw apiError(response.status, errorJson?.message || 'Failed to fetch Plaid link token', errorJson?.code);
    }

    const responseJson = await response.json();
    return responseJson.data;
  } finally {
    clearTimeout(timeout);
  }
};
